import { useTranslation } from 'react-i18next';
import { Dialog } from 'ui/shared/containers';

export type Props = {
    id?: string;
    visible: boolean;
    message: string | null;
    onClickYes: () => void;
    onClickNo: () => void;
};

const largeFont = {
    fontSize: '1.5em',
};

const topMargin = {
    marginTop: '1.5em',
};

export const ConfirmationDialog = ({ id, visible, message, onClickYes, onClickNo }: Props) => {
    const { t } = useTranslation();
    return (
        <Dialog
            id={ id || "confirmation-dialog" }
            visible={ visible }
            portalName="confirmation-portal"
        >
            <div style={ largeFont }>
                { message }
            </div>
            <div style={ topMargin }>
                <button className="ui red button" type="button" onClick={ onClickYes } autoFocus={ true }>
                    { t('COMMAND.YES') }
                </button>
                <button className="ui basic button" type="button" onClick={ onClickNo }>
                    { t('COMMAND.NO') }
                </button>
            </div>
        </Dialog>
    );
};